exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".s3Ylh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:935px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-item-align:stretch;align-self:stretch}._3BN4_{margin-right:8px;margin-left:8px;border-radius:3px;color:#000}._3BN4_:hover{color:#e73232}._29C-n{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.BZPWi{position:relative;height:100%}.BZPWi,.dmyLG{display:-webkit-box;display:-ms-flexbox;display:flex}.dmyLG{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:10px}._1XlLA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;height:100%}._3L2yd{display:inline-block;text-decoration:none;font-weight:700;font-size:13px;padding:15px 20px 15px 18px}._3PRKw{background-color:#ffd906;color:#000;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3PRKw:hover{background-color:#ffc107;color:#000}._3PRKw img{margin-right:10px}", ""]);

// exports
exports.locals = {
	"root": "s3Ylh",
	"highlight": "_3BN4_",
	"left": "_29C-n",
	"navItem": "BZPWi",
	"right": "dmyLG",
	"flexRow": "_1XlLA",
	"link": "_3L2yd",
	"sell": "_3PRKw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Navigation/Navigation.css
// module id = 1353
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46